export function sendExperimentEvent(flag_name, flag_value) {
  if (flag_value === null || flag_value === undefined) {
    return
  }

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: 'experiment_viewed',
    experiment_id: flag_name,
    variation_id: flag_value ? '1' : '0',
  })
}
